import React from 'react';
import { useTranslation } from 'react-i18next';
import BundleCard from './BundleCard';
import { IconHotBundle, IconRefreshBundle, IconSuperHotBundle } from './icons';
import { CategorySectionStyled } from './styled';

const CATEGORY_CONTENT = {
  super_hot: {
    Icon: IconSuperHotBundle,
    title: 'Super Hot Bundles',
    description: 'Maximum visibility. Place your listings at the absolute top of search results.',
  },
  hot: {
    Icon: IconHotBundle,
    title: 'Hot Bundles',
    description: 'Get a competitive edge and place your ads above normal listings.',
  },
  refresh: {
    Icon: IconRefreshBundle,
    title: 'Refresh Bundles',
    description: 'Keep your inventory fresh. Bring your posted listings to the top again.',
  },
};

// The cart response carries no stable id linking a line back to its catalogue package
// (no item_id/item_type on cart_details) — match on the fields bundles are decorated
// with instead, on both the catalogue and cart line.
const findCartLine = (cartDetails, bundle) =>
  cartDetails?.find(
    (detail) =>
      detail?.category === bundle.category &&
      detail?.total_quantity === bundle.total_quantity &&
      detail?.discount_percentage === bundle.discount_percentage,
  );

const CategorySection = ({ category, cartDetails, isBusy, onAdd, onRemove }) => {
  const { t } = useTranslation();
  const content = CATEGORY_CONTENT[category?.type];

  if (!content || !category?.bundles?.length) return null;

  const { Icon } = content;

  return (
    <CategorySectionStyled>
      <div className="category-section-header">
        <Icon />
        <div className="category-section-text">
          <h2>{t(content.title)}</h2>
          <p>{t(content.description)}</p>
        </div>
      </div>
      <div className="category-section-cards">
        {category.bundles.map((bundle) => {
          const cartLine = findCartLine(cartDetails, bundle);
          return (
            <BundleCard
              key={bundle.id}
              bundle={bundle}
              cartLine={cartLine}
              isPending={isBusy}
              onAdd={onAdd}
              onRemove={onRemove}
            />
          );
        })}
      </div>
    </CategorySectionStyled>
  );
};

export default CategorySection;
